export default __webpack_public_path__ + "static/media/maquinaDePapel.74d63a6c.jpg";